import { observer } from 'mobx-react'
import React, { useEffect, useState } from 'react'
import DefaultAutocomplete from 'src/components/customElements/InputField/components/DefaultAutocomplete'
import { isAdminType2 } from '../../../../services/AccountService'
import { getComp } from '../../../../utils/utils/DI'

function TerritoriesAutocomplete({
  value,
  autocompleteOptions,
  error,
  ...props
}) {
  const { type, territory, district, fin } = autocompleteOptions

  const [handbookCollection, setHandbookCollection] = useState([])
  const [dotationOptions, setDotationOptions] = useState([])
  const [prevTerritory, setPrevTerritorry] = useState(territory)

  const territoryStore = getComp('TerritoryStore')
  const statusStore = getComp('StatusesStore')
  const authorsStore = getComp('AuthorsStore')
  const sendersStore = getComp('SendersStore')

  const { setFinSourceId } = statusStore
  const { territories } = territoryStore
  const {
    api,
    fullWidth,
    label,
    onChange,
    onPaste,
    placeholder,
    propName,
    settings,
    styles,
    variant,
    visible,
    disabled,
  } = props
  const newProps = {
    api: api,
    fullWidth: fullWidth,
    label: label,
    onChange: onChange,
    onPaste: onPaste,
    placeholder: placeholder,
    propName: propName,
    settings: settings,
    styles: styles,
    variant: variant,
    visible: visible,
    disabled: disabled,
  }

  useEffect(() => {
    if (
      (territory && territories[territory]) ||
      type === 'authorId' ||
      type === 'sender'
    ) {
      let collection = territories[territory]

      if (type === 'locality') {
        if (
          district &&
          collection.Territory.Districts.some(
            (el) => el.Name.toLowerCase() === district.toLowerCase()
          )
        ) {
          collection = collection.Territory.Districts.find(
            (el) => el.Name.toLowerCase() === district.toLowerCase()
          ).Localities

          let withFullDotation = collection
            .filter((el) => el.AllowedFinancialSourceIds.includes(1))
            .map((el) => el.Name)

          setDotationOptions(withFullDotation)

          let collection2 =
            fin && !isAdminType2()
              ? collection.filter((locality) =>
                  locality.AllowedFinancialSourceIds.includes(fin)
                )
              : collection
          collection = collection2.map((locality) => locality.Name)

          let loc = collection2.find((locality) => locality.Name === value)
          setFinSourceId(loc?.AllowedFinancialSourceIds)
        } else {
          collection = []
          props?.onChange({ target: { value: '' } })
        }
      }

      if (type === 'district') {
        collection = collection.Territory.Districts.map((el) => el.Name)

        if (!collection.includes(value) && territory !== prevTerritory) {
          setPrevTerritorry(territory)
          props?.onChange({ target: { value: '' } })
        }
      }

      if (type === 'authorId') {
        collection = authorsStore.authors.map((el) => el.name)
      }

      if (type === 'sender') {
        collection = sendersStore.allSenders.map((el) => el.name)
      }

      if (value) {
        const newCollection = collection.filter((el) => {
          return el?.toLowerCase()?.includes(value?.toLowerCase())
        })

        if (newCollection.length) {
          setHandbookCollection(newCollection)
        } else {
          setHandbookCollection([])
        }
      } else {
        setHandbookCollection(collection)
      }
    }
  }, [value, territory, district, fin, sendersStore.allSenders])

  useEffect(() => {
    territoryStore.isReadyAsync.then(() => {
      if (type === 'territory') {
        setHandbookCollection(territoryStore.collection)
      }
    })
  }, [])

  useEffect(() => {
    if (
      propName === 'locality' &&
      !!value &&
      !handbookCollection.includes(value)
    ) {
      api?.setError('locality', 'invalid')
    } else if (propName === 'locality' && handbookCollection.includes(value)) {
      api?.clearError('locality')
    } else if (propName === 'locality' && !value && handbookCollection.length) {
      api?.setError('locality', 'require')
    }
  }, [value, handbookCollection])

  return (
    <DefaultAutocomplete
      value={value}
      handbookCollection={handbookCollection}
      dotationOptions={dotationOptions}
      error={
        props.offError
          ? false
          : (error || !handbookCollection.some((el) => el === value)) &&
            !props.disabled
      }
      {...newProps}
    />
  )
}

export default observer(TerritoriesAutocomplete)
